export type DashboardVariant = "admin" | "partner";

export type RightColumnBlockId =
  | "partnerProgram"
  | "pendingActions"
  | "eventsWeek"
  | "escalationTracker";

export type DashboardBlocksConfig = {
  showSupportStatus: boolean;
  showEscalationTracker: boolean;
  showPartnerProgram: boolean;
  showWelcomeHeader: boolean;
  showPerformanceTrend: boolean;
  showEndCustomerEcosystem: boolean;
  rightColumnOrder: RightColumnBlockId[];
};

export const DASHBOARD_BLOCKS: Record<DashboardVariant, DashboardBlocksConfig> = {
  partner: {
    showSupportStatus: false,
    showEscalationTracker: false,
    showPartnerProgram: true,
    showWelcomeHeader: true,
    showPerformanceTrend: false,
    showEndCustomerEcosystem: false,
    rightColumnOrder: ["partnerProgram", "pendingActions", "eventsWeek"],
  },
  admin: {
    showSupportStatus: true,
    showEscalationTracker: true,
    showPartnerProgram: false,
    showWelcomeHeader: false,
    showPerformanceTrend: false,
    showEndCustomerEcosystem: true,
    rightColumnOrder: ["pendingActions", "eventsWeek", "escalationTracker"],
  },
};
